import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M2.68377 9.94868C1.77208 9.64478 1.77208 8.35521 2.68377 8.05131L20.6838 2.05131C21.4655 1.79073 22.2093 2.53447 21.9487 3.31623L15.9487 21.3162C15.6448 22.2279 14.3552 22.2279 14.0513 21.3162L11.2094 12.7906L2.68377 9.94868ZM6.16228 9L12.3162 11.0513C12.6148 11.1508 12.8491 11.3852 12.9487 11.6838L15 17.8377L19.4189 4.58114L6.16228 9Z" />,
  'NearMe'
);
